// dependencies
import React from "react";

// style
import css from "./Grid.styl";

const Grid = ({ children, gap = 8, columns = ["1fr"] }) => {
	const gridTemplateColumns = columns.join(" ");

	return (
		<div style={{ gap: `${gap}px`, gridTemplateColumns }} className={`${css.grid}`}>
			{children}
		</div>
	);
};

export default Grid;
